
  import { mapActions, mapGetters, mapState } from 'vuex'

  import IconCheckmarkBorderless from '@loavies/component-library/dist/icons/icon-checkmark-borderless'

  export default {
    components: {
      IconCheckmarkBorderless,
    },
    computed: {
      ...mapState({
        sortOptions: state => state.listings.sortOptions,
        activeSortOption: state => state.listings.activeSortOption,
      }),
      ...mapGetters({
        getIsActiveSortOption: 'listings/getIsActiveSortOption',
      }),
    },
    methods: {
      ...mapActions({
        setActiveSortOption: 'listings/setActiveSortOption',
        removeActiveSortOption: 'listings/removeActiveSortOption',
      }),
      handleClick(sortOption) {
        if (this.getIsActiveSortOption(sortOption)) {
          return this.removeActiveSortOption()
        }

        this.setActiveSortOption({ sortOption })
      },
    },
  }
